import React, { useState } from 'react';
import { sendContactForm } from '../services/api';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    eventType: '',
    eventDate: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      await sendContactForm(formData);
      setSubmitMessage('¡Gracias por tu consulta! Nos pondremos en contacto contigo pronto.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        eventType: '',
        eventDate: '',
        message: ''
      });
    } catch (error) {
      console.error('Error al enviar el formulario:', error);
      setSubmitMessage('Hubo un error al enviar tu consulta. Por favor, intenta nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacto" className="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Contacto</h2>
          <p className="section-subtitle">
            Solicita una cotización personalizada.
          </p>
        </div>
        <div className="contact-content">
          <div className="contact-info">
            <h3>Información de Contacto</h3>
            <div className="info-item">
              <span className="info-icon">📧</span>
              <div>
                <strong>Email</strong>
                <p>consultas@blinkinformatica.com</p>
              </div>
            </div>
            <div className="info-item">
              <span className="info-icon">📱</span>
              <div>
                <strong>Teléfono</strong>
                <p>0054 11 21 848427</p> 
                
              </div>
            </div>
{/*             <div className="info-item">
              <span className="info-icon">📍</span>
              <div>
                <strong>Ubicación</strong>
                <p>Showroom y oficinas Bv Ameghino 555 (2700) Pergamino Buenos Aires. Servicios en Pergamino y zona. </p>
              </div>
            </div>
            <div className="info-item">
              <span className="info-icon">🕒</span>
              <div>
                <strong>Horario</strong>
                <p>Lun - Dom: 9:00 AM - 10:00 PM</p>
              </div>
            </div> */}
          </div>
{/*           <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Nombre Completo *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Teléfono *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="eventType">Tipo de Evento *</label>
                <select
                  id="eventType"
                  name="eventType"
                  value={formData.eventType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Selecciona...</option>
                  <option value="boda">Boda</option>
                  <option value="cumpleanos">Cumpleaños</option>
                  <option value="corporativo">Evento Corporativo</option>
                  <option value="fiesta">Fiesta Privada</option>
                  <option value="otro">Otro</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="eventDate">Fecha del Evento *</label>
                <input
                  type="date"
                  id="eventDate"
                  name="eventDate"
                  value={formData.eventDate}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="message">Mensaje</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                placeholder="Cuéntanos más sobre tu evento..."
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary btn-submit" disabled={isSubmitting}>
              {isSubmitting ? 'Enviando...' : 'Enviar Solicitud'}
            </button>
            {submitMessage && (
              <p className={`submit-message ${submitMessage.includes('error') ? 'error' : 'success'}`}>
                {submitMessage}
              </p>
            )}
          </form> */}
        </div>
      </div>
    </section>
  );
};

export default Contact;
